module.exports = __webpack_public_path__ + "img/add-nega.3bd4267c.png";